import {Badge, SpaceBetween} from "@cloudscape-design/components";
import {enumerateObject} from "linq-to-typescript";

export function TagList(props: { tags: { [key: string]: string } }) {
    return <SpaceBetween size={"xs"} direction={"horizontal"}>
        {enumerateObject(props.tags).select((tag,i) => <Badge key={i}>{tag[0]} = {tag[1]}</Badge>)}
    </SpaceBetween>
}